import dynamic from "next/dynamic";
import Head from 'next/head';

const Content = dynamic(() => import("@/front/index"), {ssr: false});

export default function Index(props: any) {
  return (
    <>
	    <Head>
	    	{/* <title>LightSkool</title> */}
	    	<meta name="viewport" charSet="utf-8" content="width=device-width, initial-scale=1" />
	    	<link rel="icon" href="" />
	    </Head>
      <Content />
    </>
  )
}